// eslint-disable-next-line import/prefer-default-export
export enum BillingInterval {
  MONTH = 'month',
  YEAR = 'year',
}
